import { axiosInstance } from '../Middleware'
import { ResponseGetAllType } from '../response'
import { NatureAbsenceType } from '../Natureabsence/types'

export class NatureabsenceApi {
  public static loadNatureabsence = (complement?: string) : Promise<ResponseGetAllType<NatureAbsenceType>> =>
    axiosInstance.get(`personnel/personnel/naturesabsences${complement ? `?${complement}` : ''}`)
      .then(response => response.data)
}
